# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/

$(document).on "turbolinks:load", ->
  $(".invalid_scope_article").on "click", (e)->
    e.preventDefault();
    window.open(
      "https://support.visiblebody.com/hc/en-us/articles/1260802249050-Canvas-Courseware-Integration-troubleshooting", "_blank", "noreferrer noopener");

  $(".invalid_scope_list").on "click", (e)->
    e.preventDefault();
    $('#integration_setup_scopes_modal').modal('show');